// extracted by mini-css-extract-plugin
export default {"main":"ErrorPage_main__iHEXA","div-404":"ErrorPage_div-404__6cTvn","div-text":"ErrorPage_div-text__GnnW5","btn":"ErrorPage_btn__nSSSO","green":"ErrorPage_green__t2tf4"};